
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './base/app-config.service';
import { USERAPIConstant } from '../constants/user.constant';
import { CommonService } from './common.service';
// import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  apiBaseUrl = `${AppConfigService.settings.apiUrl}`;

  cai = sessionStorage.getItem('currentUser') || ''; // Default value, can be replaced with a dynamic value
  private completeApprovalResponse: any = null;
  getCurrentFacilityId(): string {
    return localStorage.getItem('current_facility_id') || 'ES';
  }
  constructor(private http: HttpClient, private commonService: CommonService) {
    // Initialize the service with the base URL from AppConfigService
    this.apiBaseUrl = AppConfigService.settings.apiUrl;
  }
  getMaximoByUser(userId: any,type: any) {
        return this.http.get(this.apiBaseUrl + USERAPIConstant.GETPLANTLIST + `?Email=${userId}&facility=${this.commonService.getCurrentFacilityId()}&type=${type}`);
  }
  addMaximoForUser(payload: any) {
    //IGP - ISSUE SEGNALLED BY BRIAN, TODD (1.14.2025)
    //THIS IS PUTTING THE LOGGED USER EMAIL ID INSTEAD OF THE VALIDATED ONE! 
    // //payload.Email = this.cai;
    // I JUST REMOVED THIS STATEMENT ABOVE
    return this.http.post(this.apiBaseUrl + USERAPIConstant.ADDMAINTAINENCEUSERRECORD, payload);
  }
  validateUser(caiId: any) {
    return this.http.get(this.apiBaseUrl + USERAPIConstant.VALIDATEUSER + `?Email=${this.cai}`);
  }
  validateLEUser(caiId: any) {
    return this.http.get(this.apiBaseUrl + USERAPIConstant.VALIDATEUSER + `?Email=${caiId}`);
  }
}
